module.exports = __webpack_public_path__ + "img/1.c1cd5148.png";